/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S13_P1_TextInputs */

const tr_kullanim_s13_p1_text = /** @type {(inputs: Kullanim_S13_P1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici sıfatını haiz Kullanıcı, herhangi bir gerekçe göstermek zorunda olmadan, bedel ödemeksizin ve cezai şarta tabi tutulmaksızın Aboneliği her zaman, önceden haber verme süresine tabi olmaksızın iptal edebilir veya feshedebilir. Bu hak, tüketici sıfatı taşıyan Kullanıcılar bakımından sözleşme ile ortadan kaldırılamaz, sınırlandırılamaz veya bedele bağlanamaz.`)
};

const en_kullanim_s13_p1_text = /** @type {(inputs: Kullanim_S13_P1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A User qualifying as a consumer may cancel or terminate the Subscription at any time and without any advance notice period, without having to state any reason, without paying a fee and without being subject to a penalty clause. For Users qualifying as consumers this right cannot be removed, limited or made subject to a fee by contract.`)
};

const de_kullanim_s13_p1_text = /** @type {(inputs: Kullanim_S13_P1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Nutzer mit Verbrauchereigenschaft kann das Abonnement jederzeit und ohne Vorankündigungsfrist kündigen oder beenden, ohne einen Grund angeben zu müssen, ohne Entgelt und ohne Vertragsstrafe. Dieses Recht kann für Nutzer mit Verbrauchereigenschaft vertraglich weder aufgehoben noch eingeschränkt oder an ein Entgelt geknüpft werden.`)
};

const ru_kullanim_s13_p1_text = /** @type {(inputs: Kullanim_S13_P1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь, имеющий статус потребителя, может в любое время и без срока предварительного уведомления отменить или расторгнуть Подписку без объяснения причин, без оплаты и без применения штрафных санкций. В отношении Пользователей со статусом потребителя это право не может быть отменено, ограничено или обусловлено оплатой договором.`)
};

/**
* | output |
* | --- |
* | "A User qualifying as a consumer may cancel or terminate the Subscription at any time and without any advance notice period, without having to state any reaso..." |
*
* @param {Kullanim_S13_P1_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s13_p1_text = /** @type {((inputs?: Kullanim_S13_P1_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S13_P1_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s13_p1_text(inputs)
	if (locale === "de") return de_kullanim_s13_p1_text(inputs)
	if (locale === "ru") return ru_kullanim_s13_p1_text(inputs)
	return tr_kullanim_s13_p1_text(inputs)
});